import React, { useContext } from 'react'
import { AppContext } from '@state/context'
import { openFeedbackPanel } from '@state/actions/panelsActions'
import Button from '@components/Button'
import {
  BUTTON_SIZE,
  COLORS,
  DIVIDER_SIZE,
  TEXT_SIZES,
} from '@helpers/constants'
import Divider from '@components/Divider'
import Text from '@components/Text'

const SectionEnderFeedback = ({ section }) => {
  const [state, dispatch] = useContext(AppContext)

  if (!section) return null

  return (
    <div className={'mx-auto max-w-[700px] mt-12 mb-8'}>
      <Divider size={DIVIDER_SIZE.LINE} line />
      <Divider size={DIVIDER_SIZE.BASE} />

      <div className={'flex flex-col items-center'}>
        <Text size={TEXT_SIZES.XXSMALL}>
          Du kan berätta vad du tycker om avsnittet, om du vill!
        </Text>
        <Divider size={DIVIDER_SIZE.XSMALL} />

        <Button
          // type={BUTTON_TYPE.PRIMARY}
          textColor={COLORS.BLACK.TEXT}
          backgroundColor={COLORS.LIGHT_GREY.BACKGROUND}
          size={BUTTON_SIZE.MEDIUM}
          handleClick={() => {
            dispatch(
              openFeedbackPanel({
                type: 'section',
                id: section.id,
              })
            )
          }}
          icon={'PaperPlane'}
          iconRight
        >
          Skicka meddelande
        </Button>
      </div>
    </div>
  )
}

export default SectionEnderFeedback
